import { makeStyles } from '@material-ui/styles';

export default makeStyles((theme) => ({
    submitButtonWrapper: {
        paddingTop: theme.spacing(9),
        width: '70%',
        marginLeft: '15%',
        boxSizing: 'border-box',
    },
}));
